import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import trainingEvaluationScoresService from "./trainingEvalReportService";

const useTrainingEvaluationScores = () => {

    const { id: trainingId } = useParams();
    const { data, error, isFetching } = useQuery(['trainingEvalScores', trainingId], () =>
        trainingEvaluationScoresService.getTrainingEvaluationScores(trainingId), {
        initialData: {
            data: { data: [] }
        },
        keepPreviousData: true,
    });

    const { data: trainingHeader, error: trainingError, isFetching: isFetchingTraining } = useQuery(['trainingInformation', trainingId], () =>
        trainingEvaluationScoresService.getTrainingInforationsHeader(trainingId),
        {
            initialData: {
                data: { data: [] }
            },
            keepPreviousData: true,
        }
    );

    return {
        data: data?.data,
        isFetching,
        error,
        trainingHeader: trainingHeader?.data,
        trainingError,
        isFetchingTraining
    };
};

export default useTrainingEvaluationScores;